import { Link } from "react-router-dom";
import { Inbox, Loader2, ShieldAlert, ArrowLeft } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

function GuardShell({ icon: Icon, title, copy, children, testId }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-bone px-4 pt-[72px]" data-testid={testId}>
      <div className="w-full max-w-md rounded-[2rem] border border-border bg-white p-10 text-center shadow-[0_25px_70px_rgba(10,41,30,0.08)]">
        <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-gold/15 text-gold-dark">
          <Icon className="h-6 w-6" />
        </span>
        <h1 className="mt-5 font-display text-2xl font-extrabold text-forest-deep">{title}</h1>
        <p className="mt-2.5 text-sm leading-relaxed text-muted-foreground">{copy}</p>
        {children}
      </div>
    </div>
  );
}

export function AdminGuard({ children }) {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-bone pt-[72px]" data-testid="admin-loading">
        <Loader2 className="h-8 w-8 animate-spin text-forest" />
      </div>
    );
  }

  if (user === false) {
    return (
      <GuardShell icon={Inbox} title="Sign in required" testId="admin-login-required"
        copy="This admin area is private. Sign in with your admin account to continue.">
        <Link to="/login" data-testid="admin-goto-login-btn"
          className="mt-6 inline-block rounded-full bg-forest px-8 py-3.5 font-display text-sm font-bold text-bone transition-transform duration-200 hover:-translate-y-0.5">
          Go to login
        </Link>
      </GuardShell>
    );
  }

  if (user.role !== "admin") {
    return (
      <GuardShell icon={ShieldAlert} title="Admins only" testId="admin-access-denied"
        copy={`You're signed in as ${user.email}, which doesn't have admin access.`}>
        <Link to="/" data-testid="admin-back-home-btn"
          className="mt-6 inline-flex items-center gap-2 rounded-full border border-border px-6 py-3 text-sm font-semibold text-foreground/70 transition-colors hover:text-forest">
          <ArrowLeft className="h-4 w-4" /> Back to home
        </Link>
      </GuardShell>
    );
  }

  return children;
}
